export default "__VITE_ASSET__c358f217__"